<ion-content class="auth_main_wrapper">
    <div class="flex auth_inner_wrapper">
        <div class="left_column_auth column">
            <msi-auth-two-factor-form></msi-auth-two-factor-form>
        </div>
        <div class="right_column_auth column">
            <img alt="logo" src="/assets/img/app-logo/butterflyIT_Logo.svg"/>
        </div>
    </div>
</ion-content>